import showToast from "../../../custom_js/showToast";

up.compiler(".up_license", function (element) {
  function onChange(event) {
    const paying_status = event.target.value;

    up.render({
      url: `/manage-workshops-pay/${element.dataset.freskslug}/${element.dataset.workshopslug}/${paying_status}`,
      method: "put",
      target: ".js-paying-status",
      history: false,
      focus: ".up_license",
    })
      .then(() => {
        showToast("Mise à jour OK");
      })
      .catch(() => {
        showToast("Erreur : veuillez contacter le support", "red", 4000);
      });
  }
  element.addEventListener("change", onChange);
  return () => {
    element.removeEventListener("change", onChange);
  };
});
